module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"capelo.me","short_name":"capelo","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"adbf8252a0b09cd73c3366f3ccc43080"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
